/**
 * A calendar date rendered in long US form, pinned to UTC — e.g.
 * "September 30, 2026".
 *
 * One formatter for every surface that must agree on a date to the day: the
 * mandate evidence's stored first-charge display and the billing settings
 * card both render through it. Left to the reader's timezone, an instant at
 * UTC midnight renders as the previous day west of it, and two surfaces
 * formatting independently would name different dates for one debit.
 */
export function formatUtcLongDate(date: Date): string {
  return date.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
